import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IColumn, Selection } from '@fluentui/react/lib/DetailsList';
import history from '../../../history';

import ListPaneComponent from './component';
import { withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { readStockDropDownData } from '../../../reducers/stockReducer';
import { messageService } from '../../../services/messageService';
import { ListPaneItem, ProgressStatement, psFormData, PSListPaneFilter } from '../../../types/progressStatement';
import { getContractingUnit, getProject } from '../../../shared/util';
import { StockDropDowns, StockShotcutPaneFilter } from '../../../types/stock';

export interface State {
  redirect: boolean;
  isChange: boolean;
  loading: boolean;
  filter: StockShotcutPaneFilter;
  announcedMessage: string;
  selectedListItemIds: [] | string[];
  selectedListItemSequenceCode: [] | string[];
  formData: ProgressStatement;
  selectedListItems: ListPaneItem[];
}

export interface Props extends WithTranslation {
  listPaneItems: ListPaneItem[];
  reloadListPaneItem: () => void;
  handelFilter: (filter: StockShotcutPaneFilter) => void;
  isSTOCKListLoaded?: boolean;
  isChange: boolean;
  filter: PSListPaneFilter;
  resourceTypes: [];
  loadMsg: string;
  toleranceStatesFilter: [];
  productStatesFilter: [];
  itemTypesFilter: [];
  handleSelectedListPaneItem: (selectedItemIds: [] | string[]) => void;
  formData: ProgressStatement;
  projectId: string | null;
  stockDropDowns: StockDropDowns;
  reSizer: number;
  readStockDropDownData: () => void;
  warehouseTaxonomy: any;
}

class ListPane extends Component<Props, State> {
  private _Selection: Selection;
  private _columns: IColumn[];
  private _columnsReSizer: IColumn[];
  //private _columnsCu: IColumn[];
  subscription: any;

  constructor(props: Props) {
    super(props);
    this._Selection = new Selection({
      onSelectionChanged: () => {
        this.setState(
          {
            selectedListItemIds: this._getSelectedIds(),
            selectedListItemSequenceCode: this._getselectedSequenceCode(),
            selectedListItems: this._getSelectedListItems(),
          },
          this.handleSelectedItem,
        );
      },
    });
    this.state = {
      selectedListItems: [],
      selectedListItemIds: [],
      selectedListItemSequenceCode: [],
      redirect: false,
      isChange: false,
      loading: false,
      announcedMessage: '',
      filter: new StockShotcutPaneFilter(),
      formData: psFormData,
    };

    this._columns = [
      {
        key: 'column1',
        name: this.props.t('stockItemTitle'),
        fieldName: 'title',
        minWidth: 165,
        maxWidth: 200,
        isResizable: true,

        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column2',
        name: this.props.t('type'),
        fieldName: 'type',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column3',
        name: this.props.t('status'),
        fieldName: 'status',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column4',
        name: this.props.t('quantity'),
        fieldName: 'count',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        onRender: (item: any) => {
          return <div style={{ maxWidth: 200, display: 'flex', justifyContent: 'flex-end' }}>
            {item?.count && <span>{(item?.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>}
          </div>
        }
      },
      {
        key: 'column5',
        name: this.props.t('warehouse'),
        fieldName: 'wareHouse',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column6',
        name: this.props.t('warehouseTaxonomy'),
        fieldName: 'warehouseTaxonomy',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
      },
    ];
    this._columnsReSizer = [
      {
        key: 'column1',
        name: this.props.t('stockItemTitle'),
        fieldName: 'title',
        minWidth: 165,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
    ];
    // this._columnsCu = [
    //   {
    //     key: 'column1',
    //     name: this.props.t('stockItemTitle'),
    //     fieldName: 'title',
    //     minWidth: 100,
    //     maxWidth: 200,
    //     isResizable: true,
    //     isSorted: true,
    //     onColumnClick: this._onColumnClick,
    //   },
    //   {
    //     key: 'column2',
    //     name: this.props.t('type'),
    //     fieldName: 'type',
    //     minWidth: 100,
    //     maxWidth: 200,
    //     isResizable: true,
    //     onColumnClick: this._onColumnClick,
    //   },
    //   {
    //     key: 'column3',
    //     name: this.props.t('status'),
    //     fieldName: 'status',
    //     minWidth: 100,
    //     maxWidth: 200,
    //     isResizable: true,
    //     onColumnClick: this._onColumnClick,
    //   },
    //   {
    //     key: 'column4',
    //     name: this.props.t('warehouseTaxonomy'),
    //     fieldName: 'warehouseTaxonomy',
    //     minWidth: 100,
    //     maxWidth: 200,
    //     isResizable: true,
    //   },
    // ];
  }

  // static getDerivedStateFromProps(nextProps: any) {
  //   if (nextProps.isChange) {
  //     nextProps.reloadListPaneItem();
  //   }
  //   return {
  //     loading: false,
  //     filter: nextProps.filter,
  //     formData: nextProps.formData,
  //   };
  // }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  componentDidMount() {
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.resetListPaneSelection) {
          // this._Selection.setAllSelected(false);
          // this.resetSelection();
        }
        if (data.data.isNewStock) {
          this._Selection.setAllSelected(false);
          // this.resetSelection();
        }
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.isSTOCKListLoaded != this.props.isSTOCKListLoaded) {
      if (this.props.isSTOCKListLoaded) {
        this.resetSelection();
      }
    }
  }

  handleListPaneItemClick = (id: string) => {
    if (getContractingUnit() && getProject()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock/${id}`);
    } else {
      history.push(`/CU/${getContractingUnit()}/stock/${id}`);
    }
  };

  handleSelectedItem = () => {
    this.props.handleSelectedListPaneItem(this.state.selectedListItemIds);
    if (this.state.selectedListItemSequenceCode) {
      let lastId = this.state.selectedListItemSequenceCode.pop();
      if (lastId) {
        this.handleListPaneItemClick(lastId);
      }
    }
  };

  handleFilterChange = (filter: StockShotcutPaneFilter) => {
    this.props.handelFilter(filter);
  };

  handleFilterSortChange = () => {
    this.props.handelFilter(this.state.filter);
  };

  resetSelection = () => {
    if (
      this.state.formData &&
      this.state.formData.progressStatementId &&
      this.props.isSTOCKListLoaded
    ) {
      this._Selection.setKeySelected(
        this.state.formData.progressStatementId,
        true,
        false,
      );
    } else {
      this._Selection.selectToKey('', true);
    }
  };

  render() {
    return (
      <div>
        <ListPaneComponent
          listPaneItems={
            this.props.listPaneItems ? this.props.listPaneItems : []
          }
          selection={this._Selection}
          handleListPaneItemClick={(id: string) =>
            this.handleListPaneItemClick(id)
          }
          resetSelection={() => this.resetSelection()}
          formData={this.state.formData}
          //columns={(getProject())?(this.props.reSizer===300)?this._columnsReSizer:this._columns:(this.props.reSizer===300)?this._columnsReSizer:this._columnsCu}
          columns={(this.props.reSizer === 300) ? this._columnsReSizer : this._columns}
          filter={this.props.filter}
          loadMsg={this.props.loadMsg}
          resourceTypes={this.props.resourceTypes}
          handleFilterChange={(filter: StockShotcutPaneFilter) =>
            this.handleFilterChange(filter)
          }
          isDataLoaded={this.props.isSTOCKListLoaded}
          dropDownOptions={{
            ...this.props.stockDropDowns,
            warehouseTaxonomy: this.props.warehouseTaxonomy?.length > 0 ? this.props.warehouseTaxonomy : [],
          }}
        />
      </div>
    );
  }

  private _getSelectedIds() {
    let deleteList: any = [];
    let SelectedItem = this._Selection.getSelection() as ListPaneItem[];
    if (SelectedItem) {
      deleteList = SelectedItem.map((item: any) => {
        return item ? item.id : null;
      });
    }
    return deleteList;
  }

  private _getselectedSequenceCode() {
    let selectedList: any = [];
    let selectedItem = this._Selection.getSelection() as ListPaneItem[];
    if (selectedItem) {
      selectedList = selectedItem.map((item: any) => {
        return item ? item.sequenceId : null;
      });
    }
    return selectedList;
  }

  private _getSelectedListItems = () => {
    let SelectedListItems = this._Selection.getSelection() as ListPaneItem[];

    return SelectedListItems;
  };

  private _onColumnClick = (
    ev: React.MouseEvent<HTMLElement>,
    column: IColumn,
  ): void => {
    const newColumns: IColumn[] = this._columns.slice();
    const currColumn: IColumn = newColumns.filter(
      (currCol) => column.key === currCol.key,
    )[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
        let filter = this.state.filter;

        let fieldName = currColumn.fieldName;

        let sortby = currColumn.isSortedDescending ? 'desc' : 'asc';
        filter.sorter.attribute = fieldName ? fieldName : null;
        filter.sorter.order = sortby ? sortby : null;
        this.setState(
          {
            filter: filter,
          }, () => {
            this.handleFilterSortChange();
          },
        );
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    // toleranceStatesFilter:state.projectBreakdown.toleranceStatesFilter,
    // productStatesFilter: state.projectBreakdown.productStatesFilter,
    // itemTypesFilter: state.projectBreakdown.itemTypesFilter,
    isChange: state.stock.isChange,
    stockDropDowns: state.stock.stockDropDowns,
    isSTOCKListLoaded: state.stock.isSTOCKListLoaded,
    loadMsg: state.stock.loadMsg,
    warehouseTaxonomy: state.warehouse.warehouseTaxonomy,
  };
};

const mapDispatchToProps = {
  readStockDropDownData,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListPane)),
);
